import styled from "@emotion/styled";
import { Box, Typography } from "@mui/material";

export const DocumentContentWrapper = styled(Box)`
  width: 100%;
  padding: 8px;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const DocumentContentIcon = styled.img`
  max-width: 32px;
  margin-right: 8px;
`;

export const DocumentTextWrapper = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const DocumentContentText = styled(Typography)`
  opacity: 0.5;
  text-align: left;
`;
